import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('PUT', `/api/v2/listing/${listingId}/unpublish`);
